<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="关键词">
								<a-input v-model="queryParams.word" placeholder="关键词" />
							</a-form-item>
						</a-col>
						<template v-if="advanced">
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/op/riskWordAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">

				<template slot="action" slot-scope="record">
					<a-popconfirm placement="topRight" title="你确定要删除本条记录?" @confirm="wordDel(record.id)">
						<a v-has="'/op/riskWordDel'" href="#">删除</a>
					</a-popconfirm>
					<a-divider type="vertical" />
					<a v-has="'/op/riskWordUpdate'" @click="update(record)">修改</a>
				</template>
			</a-table>

			<risk-word-form-modal ref="RiskWordForm" :visible="RiskWordFormVisible" :loading="RiskWordFormLoading" :model="RiskWordFormModel"
				@cancel="RiskWordFormCancel" @ok="RiskWordFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import RiskWordFormModal from "@/pages/op/risk_word/RiskWordForm.vue";
	import {
		riskWordList,
		riskWordAdd,
		riskWordUpdate,
		riskWordDel
	} from "@/api/op/riskWord.js";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '关键词',
			dataIndex: 'word'
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			RiskWordFormModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				RiskWordFormVisible: false,
				RiskWordFormLoading: false,
				RiskWordFormModel: null,
				createTime: [],
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				riskWordList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			add() {
				this.RiskWordFormModel = null;
				this.RiskWordFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.RiskWordForm && this.$refs.RiskWordForm.initForm) {
						this.$refs.RiskWordForm.initForm();
					}
				});
			},
			update(record) {
				this.RiskWordFormModel = {
					...record
				};
				this.RiskWordFormVisible = true;
			},
			RiskWordFormOk() {
				const wordForm = this.$refs.RiskWordForm;
				if (!wordForm || !wordForm.$refs.adminForm) {
					return;
				}
				wordForm.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...wordForm.form };
					this.RiskWordFormLoading = true;
					if (values.id > 0) {
						const payload = {
							id: values.id,
							word: (values.word || '').trim(),
						};
						riskWordUpdate(payload).then((res) => {
							if (res.isSucceed) {
								this.RiskWordFormAfter('修改关键词成功');
							} else {
								this.RiskWordFormLoading = false;
							}
						}).catch(() => {
							this.RiskWordFormLoading = false;
						});
					} else {
						riskWordAdd(values).then((res) => {
							if (res.isSucceed == true && res.data.status == 'ok') {
								let msg = '新增关键词成功';
								if (res.data.repeatNum > 0) {
									msg += `,已过滤${res.data.repeatNum}个重复关键词`;
								}
								this.RiskWordFormAfter(msg);
							} else {
								this.RiskWordFormLoading = false;
							}
						}).catch(() => {
							this.RiskWordFormLoading = false;
						});
					}
				});
			},
			RiskWordFormCancel() {
				this.RiskWordFormModel = null;
				this.RiskWordFormVisible = false;
				if (this.$refs.RiskWordForm && this.$refs.RiskWordForm.initForm) {
					this.$refs.RiskWordForm.initForm();
				}
			},
			RiskWordFormAfter(message) {
				this.RiskWordFormVisible = false;
				this.RiskWordFormLoading = false;
				if (this.$refs.RiskWordForm && this.$refs.RiskWordForm.initForm) {
					this.$refs.RiskWordForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			rest() {
				this.createTime = [];
				this.queryParams = {};
				this.pageIndex = 1;
				this.fetchTableData();
			},
			wordDel(id) {
				riskWordDel(id).then(() => {
					this.fetchTableData();
					this.RiskWordFormAfter('删除关键词成功');
				});
			},
		}
	}
</script>

<style lang="less" scoped>

</style>
